import PropTypes from "prop-types";

import { t } from "../../services";
import {
  CircleIconButton,
  FlexContainers,
  Paragraph2,
  SVG,
  WrapperContainer
} from "../../components";
import { TextWrapper } from "./styled";

const CircleAddButtonTemplate = ({ text, secondaryText, onClick = () => {} }) => {
  return (
    <WrapperContainer Container={FlexContainers.FlexColumnCenter} width={"100%"} gap={16}>
      {text && (
        <TextWrapper Container={FlexContainers.FlexColumnCenter}>
          <Paragraph2>{t(text)}</Paragraph2>
          {secondaryText && <Paragraph2>{t(secondaryText)}</Paragraph2>}
        </TextWrapper>
      )}

      <CircleIconButton onClick={onClick}>
        <SVG.PlusIcon />
      </CircleIconButton>
    </WrapperContainer>
  );
};

CircleAddButtonTemplate.propTypes = {
  text: PropTypes.string,
  secondaryText: PropTypes.string,
  onClick: PropTypes.func.isRequired
};

export default CircleAddButtonTemplate;
